<template>
  <div class="serviceLevels" ref="serviceLevels">
    <!-- <div class="box is-shadowless"> -->
      <div class="columns">
        <div class="column is-4">
          <filters
            :organization="organization"
            :contract-id="contractId"
            :height="fullHeight"
            @filter="onFilter" @create="() => fetch()"
          />
        </div>
        <div class="column is-8">
          <service-levels-table
            :height="fullHeight || undefined"
            :service-levels="filteredServiceLevels"
            :loading="fetching"
          />
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Filters from "./partials/filters";
import ServiceLevelsTable from "./partials/table";
import { ServiceLevelService } from "@/services/serviceLevel.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  serviceLevelService: ServiceLevelService,
  props: {
    organization: {
      type: Object
    },
    contractId: {
      type: [String, Number],
    },
  },
  components: {
    Filters,
    ServiceLevelsTable
  },
  data: () => ({
    fullHeight: 0,
    serviceLevels: [],
    filters: {
      firm: "",
      status: "",
      priority: "",
      isUrban: null,
      includeArchived: false
    },
    fetching: false
  }),
  computed: {
    filteredServiceLevels() {
      let serviceLevels = JSON.parse(JSON.stringify(this.serviceLevels));

      return serviceLevels.filter(serviceLevel => {
        if (this.filters.firm) {
          if (serviceLevel.firm.id != this.filters.firm) {
            return false;
          }
        }

        if (this.filters.status !== "") {
          if (serviceLevel.status !== this.filters.status) {
            return false;
          }
        }

        if (this.filters.priority) {
          if (!serviceLevel.priorityCode) return false;
          if (serviceLevel.priorityCode.id !== this.filters.priority) {
            return false;
          }
        }

        if (this.filters.isUrban !== null) {
          if (serviceLevel.density != this.filters.isUrban) {
            return false;
          }
        }

        return this.filters.includeArchived
          ? true
          : serviceLevel.archivedAt
          ? false
          : true;
      });
    }
  },
  mounted() {
    this.fullHeight = this.$refs.serviceLevels.clientHeight;
    this.fetch();
  },
  methods: {
    async fetch() {
      this.fetching = true;

      this.serviceLevels = await this.$options.serviceLevelService
        .all({
          // firm_id: this.organization ? this.organization.id : undefined,
          contract_id: this.contractId || undefined,
          includes: "firmAssociation.firm,priorityCode,region"
        })
        .then(resposne => JsonDenormalizer.denormalize(resposne));

      this.fetching = false;
    },
    onFilter(filters) {
      this.filters = filters;
    },
    archivedOrRestored(serviceLevel){
      this.serviceLevels.find((service, key) => {
        if (service.id == serviceLevel.id) {
          this.$set(this.serviceLevels, key, serviceLevel);
        }
      });

      this.filters = JSON.parse(JSON.stringify(this.filters));

  }
  }
};
</script>

<style lang="scss">
.serviceLevels {
  height: 88vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ServiceLevels/list/index.vue